[
  {
    "id": 11,
    "name": "Shadi Package (5-in-1)",
    "nameUrdu": "شادی پیکج (مکمل قدرتی کورس)",
    "description": "Mega 5-in-1 herbal course combining ORX Tablets, Safoof Zakawat, Titan Turkish Majoon, Rahat Meda Safoof, and Titan Turkish Tilla for total strength, vitality, and stamina.",
    "price": 11000,
    "originalPrice": 13350,
    "discount": 15,
    "category": "package",
    "isPackage": true,
    "size": "5 Items",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.44 (1).jpeg",
    "rating": 5.0,
    "reviews": 68,
    "badges": ["bestseller", "package", "discount"],
    "packageItems": [
      {
        "name": "ORX Tablets",
        "nameUrdu": "او آر ایکس ٹیبلیٹس",
        "size": "30 Tablets",
        "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.46 (1).jpeg"
      },
      {
        "name": "Safoof Zakawat",
        "nameUrdu": "سفوف ذکاوت",
        "size": "100 gram",
        "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (1).jpeg"
      },
      {
        "name": "Titan Turkish Majoon",
        "nameUrdu": "ٹائٹن ترکش مجون",
        "size": "130 gram",
        "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.44 (1).jpeg"
      },
      {
        "name": "Rahat Meda Safoof",
        "nameUrdu": "راحت معدہ سفوف",
        "size": "100 gram",
        "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (2).jpeg"
      },
      {
        "name": "Titan Turkish Tilla",
        "nameUrdu": "ٹائٹن ترکش تِلا",
        "size": "15ml",
        "image": "/src/assets/Products/image_639be8.jpeg"
      }
    ]
  },
  {
    "id": 1,
    "name": "ORX Tablets",
    "nameUrdu": "او آر ایکس ٹیبلیٹس",
    "description": "Increases male strength and eliminates nervous weakness",
    "descriptionUrdu": "مردانہ طاقت میں اضافہ اور اعصابی کمزوری کو دور کرتا ہے",
    "price": 2650,
    "originalPrice": 3500,
    "discount": 24,
    "category": "tablets",
    "size": "30 Tablets",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.46 (1).jpeg",
    "rating": 4.8,
    "reviews": 34,
    "badges": ["bestseller", "discount"]
  },
  {
    "id": 2,
    "name": "Natural Balance Fat Loss",
    "nameUrdu": "نیچرل بیلنس فیٹ لاس",
    "description": "Reduces obesity and eliminates excess fat effectively",
    "descriptionUrdu": "موٹاپے کو کم اور فالتو چربی کو ختم کرتا ہے",
    "price": 2000,
    "originalPrice": 2500,
    "discount": 20,
    "category": "tablets",
    "size": "30 Tablets",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47.jpeg",
    "rating": 4.2,
    "reviews": 18,
    "badges": ["discount", "new"]
  },
  {
    "id": 3,
    "name": "Habshi Tail Khas",
    "nameUrdu": "حبشی تیل خاص",
    "description": "Increases size and improves timing naturally",
    "descriptionUrdu": "سائز اور ٹائمنگ میں اضافہ",
    "price": 2000,
    "originalPrice": 2500,
    "discount": 20,
    "category": "oil",
    "size": "15ml",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.44.jpeg",
    "rating": 4.5,
    "reviews": 22,
    "badges": ["discount"]
  },
  {
    "id": 4,
    "name": "Titan Turkish Majoon",
    "nameUrdu": "ٹائٹن ترکش مجون",
    "description": "For nerve and brain strength, hardness and maintaining youthfulness",
    "descriptionUrdu": "قوت اعصاب و دماغ ۔ عضو میں سختی اور جوانی کو برقرار رکھنے کے لیے",
    "price": 3450,
    "originalPrice": 4000,
    "discount": 14,
    "category": "majoon",
    "size": "130 gram",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.44 (1).jpeg",
    "rating": 4.3,
    "reviews": 15,
    "badges": ["discount"]
  },
  {
    "id": 5,
    "name": "Big Bull Essential Oil",
    "nameUrdu": "بگ بل ایسنشل آئل",
    "description": "Premium formula for size and timing enhancement",
    "descriptionUrdu": "نفس کے سائز اور ٹائمنگ میں اضافہ کرتا ہے",
    "price": 5000,
    "originalPrice": 5000,
    "discount": 0,
    "category": "oil",
    "size": "15ml",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.46.jpeg",
    "rating": 4.6,
    "reviews": 12,
    "badges": ["bestseller"]
  },
  {
    "id": 6,
    "name": "Regrow Herbal Hair Oil",
    "nameUrdu": "ریگرو ہربل ہیئر آئل",
    "description": "Made from natural herbs — complete solution for hair health",
    "descriptionUrdu": "قدرتی جڑی بوٹیوں سے تیار ۔ بالوں کا مکمل علاج",
    "price": 2300,
    "originalPrice": 3000,
    "discount": 23,
    "category": "oil",
    "size": "200ml",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.42.jpeg",
    "rating": 4.4,
    "reviews": 28,
    "badges": ["discount", "new"]
  },
  {
    "id": 7,
    "name": "Titan Premium Turkish Majoon",
    "nameUrdu": "ٹائٹن پریمیم ترکش مجون",
    "description": "For male weakness, hardness, and improving marital relations",
    "descriptionUrdu": "مردانہ کمزوری ۔ عضو میں سختی ۔ سٹیمنا اور ازواجی تعلق بہتر کرنے کے لیے",
    "price": 4999,
    "originalPrice": 6000,
    "discount": 17,
    "category": "majoon",
    "size": "120 gram",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.43.jpeg",
    "rating": 4.9,
    "reviews": 41,
    "badges": ["bestseller", "discount"]
  },
  {
    "id": 8,
    "name": "Rahat Meda Safoof",
    "nameUrdu": "راحت معدہ سفوف",
    "description": "For stomach heat, bloating and maintaining digestive balance",
    "descriptionUrdu": "معدہ کی گرمی ۔ بھاری پن اور ہاضمے کو بہتر رکھنے کے لیے",
    "price": 1200,
    "originalPrice": 1500,
    "discount": 20,
    "category": "safoof",
    "size": "100 gram",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (2).jpeg",
    "rating": 4.1,
    "reviews": 9,
    "badges": ["discount"]
  },
  {
    "id": 9,
    "name": "Safoof Zakawat",
    "nameUrdu": "سفوف ذکاوت",
    "description": "Thickens semen and eliminates bladder heat",
    "descriptionUrdu": "منی کو گاڑھا اور مثانے کی گرمی ختم کرتا ہے",
    "price": 1800,
    "originalPrice": 2200,
    "discount": 18,
    "category": "safoof",
    "size": "100 gram",
    "image": "/src/assets/Products/WhatsApp Image 2026-08-31 at 16.04.47 (1).jpeg",
    "rating": 4.7,
    "reviews": 19,
    "badges": ["discount", "bestseller"]
  },
  {
    "id": 10,
    "name": "Titan Turkish Tilla",
    "nameUrdu": "ٹائٹن ترکش تِلا",
    "description": "Increases size and improves timing naturally",
    "descriptionUrdu": "نفس کے سائز اور ٹائمنگ میں اضافہ کرتا ہے",
    "price": 4250,
    "originalPrice": 5000,
    "discount": 15,
    "category": "oil",
    "size": "15ml",
    "image": "/src/assets/Products/image_639be8.jpeg",
    "rating": 4.8,
    "reviews": 24,
    "badges": ["discount", "new"]
  }
]